<template>
  <table class="tbl">
    <slot name="colgroup"/>
    <thead>
      <tr>
        <th v-for="(item, index) in headerList" :key="index"
          :class="{ 'first-item': index === 0, 'txt-left': item.alignLeft }">
          <template v-if="item.sortColumn">
            <span class="inner_item"
              @mouseenter="item.showSortOption = true"
              @mouseleave="item.showSortOption = false">
              <span v-html="item.name"/>
              <span class="btn_sort">
                <i class="icon icon--sorting-default"
                  :class="{
                    asc: item.sortColumn === sortColumn && isSortAsc,
                    desc: item.sortColumn === sortColumn && !isSortAsc
                  }"></i>
              </span>
              <span class="sort_item" v-if="item.showSortOption">
                <button type="button" class="sort_order"
                  :class="{ on: item.sortColumn === sortColumn && isSortAsc }"
                  @click="onSortItemClick(item, true)">
                  {{ $t('common.table.header.sort.asc') }}
                </button>
                <button type="button" class="sort_order sort_order2"
                  :class="{ on: item.sortColumn === sortColumn && !isSortAsc }"
                  @click="onSortItemClick(item, false)">
                  {{ $t('common.table.header.sort.desc') }}
                  </button>
              </span>
            </span>
          </template>
          <span v-else v-html="item.name"/>
          <slot v-if="item.inReady" name="inReady"></slot>
        </th>
      </tr>
    </thead>
    <slot/>
  </table>
</template>

<script>
export default {
  name: 'AppTable',
  props: [
    'headers',
    'sortColumn',
    'isSortAsc'
  ],
  data () {
    return {
      headerList: this.headers.map(item => {
        return {
          ...item,
          showSortOption: false
        }
      })
    }
  },
  methods: {
    onSortItemClick (item, isAsc) {
      this.$emit('onSortOptionChange', item.sortColumn, isAsc)
      item.showSortOption = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  thead {
    tr {
      background-color: #555;
      .btn_sort {
        position: absolute;
        top: 50%;
        right: -20px;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
      }
    }
    th {
      position: relative;
      height: 50px;
      color: #fff;
      line-height: 1.23;

      &:first-of-type:before,
      &:last-of-type:before {
        content: "";
        display: inline-block;
        width: 15px;
        height: 50px;
        position: absolute;
        top: 0;
        left: -5px;
        background-color: #555;
        border-radius: 5px;
      }

      &:last-of-type:before {
        left: auto;
        right: -5px;
      }

      .inner_item {
        position: relative;
        line-height: 16px;
        display: inline-block;
      }
      .sort_item {
        overflow: hidden;
        position: absolute;
        top: -23px;
        left: 100%;
        min-width: 140px;
        border-radius: 6px;
        box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08),
          0 0 0 1px rgba(0, 0, 0, 0.25);
        background-color: #fff;
        z-index: 99;
        .sort_order {
          width: 100%;
          display: inline-block;
          line-height: 32px;
          padding-left: 8px;
          padding-right: 8px;
          text-align: left;
          white-space: nowrap;
          &:before {
            display: inline-block;
            content: "";
            width: 16px;
            height: 16px;
            margin: 9px 5px 0 0;
            background-image: url(../../assets/img/icon_sort_asc.svg);
            vertical-align: top;
          }
          &:hover {
            background-color: #ebebeb;
          }
          &.on {
            background-color: #fff;
            color: $brandColor;
            font-weight: 500;
            pointer-events: none;
            &:before {
              background-image: url(../../assets/img/icon_sort_asc_on.svg);
            }
          }
        }
        .sort_order2 {
          &:before {
            background-image: url(../../assets/img/icon_sort_desc.svg);
          }
          &.on:before {
            background-image: url(../../assets/img/icon_sort_desc_on.svg);
          }
        }
      }
    }
  }
  .txt-left {
    text-align: left;
  }
  .first-item {
    padding-left: 10px;
  }
}
</style>
